"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import { initializeIntercom, shutdownIntercom } from "@/lib/intercom";
import { isSensitiveAuthLocation } from "@/lib/sensitive-auth-path";

export const IntercomWrapper = ({
  intercomAppId
}: {
  intercomAppId: string;
}) => {
  // BRE-9668: the messenger reports the page URL, and auth pages' URLs carry
  // tokens. Decide in the effect itself, not a state update: the ancestor's
  // `useIntercom` effect runs right after this one and only identifies a
  // messenger that is already booted. Boot or shut down only on a flip, since a
  // reboot drops that identity.
  const pathname = usePathname();
  const bootedRef = useRef(false);

  useEffect(() => {
    const sensitive = isSensitiveAuthLocation(window.location.href);
    if (!sensitive && !bootedRef.current) {
      initializeIntercom(intercomAppId, undefined);
      bootedRef.current = true;
    } else if (sensitive && bootedRef.current) {
      shutdownIntercom();
      bootedRef.current = false;
    }
  }, [intercomAppId, pathname]);

  useEffect(
    () => () => {
      if (bootedRef.current) {
        shutdownIntercom();
        bootedRef.current = false;
      }
    },
    []
  );

  return null;
};
